import { Auth } from 'aws-amplify';
import userToken from './resume/userToken';
import Logger from './services/Logger';

/**
 * While the export document runs on AWS server, the only way we can fetch the current user is
 * with the token that we pass as query param
 */
export default async (type) => {
  try {
    if (type === 'EXPORT') {
      const userTokenArray = userToken();
      return userTokenArray[1];
    }
    const user = await Auth.currentAuthenticatedUser();
    return user?.signInUserSession?.idToken?.jwtToken;
  } catch (err) {
    Logger.LogError(err);
    return null;
  }
};
